import { useEffect } from 'react'
import { useTranslation } from 'react-i18next';

import { images } from '../../constants';
import './navbar.scss';

const Navbar = () => {
  const { t, i18n } = useTranslation();

  const toggleLanguage = () => {
    const newLang = i18n.language === 'en' ? 'ar' : 'en';
    i18n.changeLanguage(newLang);
  };

  // Update document direction when language changes
  useEffect(() => {
    document.documentElement.dir = i18n.language === 'ar' ? 'rtl' : 'ltr';
    document.documentElement.lang = i18n.language;
  }, [i18n.language]);

  const navItems = [
    { key: 'aboutUs', href: 'About Us' },
    { key: 'skills', href: 'Skills' },
    { key: 'services', href: 'Services' },
    { key: 'partners', href: 'Partners' },
    { key: 'successStories', href: 'Success Stories' },
    { key: 'whyUs', href: 'Why Us' },
  ];

  return (
<nav className="app__navbar">
    <div className="app__navbar-logo">
    <a href="#Top"><img src={images.logo} alt="NAIRDC Logo" /> </a>
      </div>
      <div className='navbar__right'>
    <ul className="app__navbar-links">
    {navItems.map((item) => (
          <li key={item.key}>
            <div />
        <a href={`#${item.href}`}>{t(`nav.${item.key}`)}</a>
          </li>
    ))}
      </ul>
      <div className='navbar__buttons'>
        <button className='language__btn' onClick={toggleLanguage}>
          <h3>{t('nav.language')}</h3>
        </button>
        <a href="#Contact Us"><button className="contact__btn">{t('nav.contact')}</button></a>
        </div>

        <div className="app__social-media">
          <a target="_blank" rel="noopener noreferrer" href="https://www.linkedin.com/in/NAIRDCBH"><img src={images.linkedInIcon} alt="LinkedIn" /></a>
          <a target="_blank" rel="noopener noreferrer" href="https://www.instagram.com/NAIRDC_BH/"><img src={images.instagramIcon} alt="Instagram" /></a>
          <a target="_blank" rel="noopener noreferrer" href="https://www.x.com/nairdc_bh/"><img src={images.xIcon} alt="X" /></a>
        </div>
      </div>
</nav>
  )
}

export default Navbar;